"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _StackingLayout = _interopRequireDefault(require("../Layouts/StackingLayout"));

var _FlexItem = _interopRequireDefault(require("../Layouts/FlexItem"));

var _TextLabel = _interopRequireDefault(require("../Typography/TextLabel"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Radio =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Radio, _React$Component);

  function Radio(props) {
    var _this;

    _classCallCheck(this, Radio);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Radio).call(this, props));

    _this.handleOnChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled,
          checked = _this$props.checked;

      if (disabled || checked) {
        return;
      }

      if (onChange) {
        onChange(event.currentTarget.value);
      }
    };

    _this.inputRef = _react.default.createRef();
    return _this;
  }
  /**
   * @override
   */


  _createClass(Radio, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.inputRef.current.checked = this.props.checked;
    }
    /**
     * @override
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.inputRef.current.checked = this.props.checked;
    }
    /**
     * Handle on Radio click.
     * @param {ReactEvent} event - click event.
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          additionalInfo = _this$props2.additionalInfo,
          disabled = _this$props2.disabled,
          checked = _this$props2.checked,
          name = _this$props2.name,
          children = _this$props2.children,
          onChange = _this$props2.onChange,
          componentDisplayName = _this$props2.componentDisplayName,
          value = _this$props2.value,
          props = _objectWithoutProperties(_this$props2, ["className", "additionalInfo", "disabled", "checked", "name", "children", "onChange", "componentDisplayName", "value"]);

      var styleProps = {
        'data-disabled': disabled,
        'data-checked': checked
      };
      var textLabelType = disabled ? _TextLabel.default.TEXT_LABEL_TYPE.INFO : _TextLabel.default.TEXT_LABEL_TYPE.PRIMARY;
      var titleNode = children;

      if (typeof children === 'string') {
        titleNode = _react.default.createElement(_TextLabel.default, {
          type: textLabelType
        }, children);
      }

      var additionalInfoNode;

      if (additionalInfo) {
        if (typeof additionalInfo === 'string') {
          additionalInfoNode = _react.default.createElement(_TextLabel.default, {
            "data-additional-info": "string",
            type: disabled ? _TextLabel.default.TEXT_LABEL_TYPE.INFO : _TextLabel.default.TEXT_LABEL_TYPE.SECONDARY
          }, additionalInfo);
        } else {
          additionalInfoNode = _react.default.createElement(_FlexLayout.default, {
            "data-additional-info": "non-string"
          }, _react.default.createElement("span", {
            className: "left-vertical-border"
          }), _react.default.createElement(_FlexItem.default, {
            flexGrow: "1"
          }, additionalInfo));
        }
      }

      return _react.default.createElement(_StackingLayout.default, {
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-radio")),
        itemSpacing: "15px"
      }, _react.default.createElement(_FlexLayout.default, _extends({
        className: "radio-title"
      }, styleProps, {
        htmlTag: "label",
        itemSpacing: "10px",
        alignItems: "center"
      }), _react.default.createElement("span", {
        className: "".concat(_ThemeManager.default.getVar('classPrefix'), "-radio-input-wrapper")
      }, _react.default.createElement("input", _extends({
        type: "radio"
      }, props, {
        name: name,
        disabled: disabled,
        value: value,
        onChange: this.handleOnChange,
        ref: this.inputRef
      })), _react.default.createElement("span", {
        className: "radio-style"
      })), titleNode), additionalInfoNode);
    }
  }]);

  return Radio;
}(_react.default.Component);

exports.default = Radio;
Radio.defaultProps = {
  disabled: false,
  checked: false,

  /**
   * TODO: This is currently being used in RadioGroup to ensure
   * that all children are actually is a 'Radio' component.
   * Couldn't find a better way from google search.
   */
  componentDisplayName: 'Radio'
};
Radio.propTypes = {
  /**
   * Custom class name added to the component.
   */
  className: _propTypes.default.string,

  /**
   * Disable styling.
   * NOTE: When disable set to true, onChange won't be callback on click.
   */
  disabled: _propTypes.default.bool,

  /**
   * Check or uncheck the radio button.
   */
  checked: _propTypes.default.bool,

  /**
   * Callback function when component is clicked to check.
   * NOTE: Application must define this to handle check state change
   * and set the props.checked appropriately.
   *
   * onChange(value)
   * value = the unique key from props.value.
   */
  onChange: _propTypes.default.func,

  /**
   * This is the label of the radio.  If this is a string then
   * it will be styled correctly using TextLabel.  For other React element
   * type it is up to the application to define the styling.
   * See additionalInfo if you need to add more text and styling.
   */
  children: _propTypes.default.node,

  /**
   * This is the additional string or React element that can be display
   * below the Radio title(children string). NOTE: When passing in a React
   * node it is up to the application to style appropriately.
   */
  additionalInfo: _propTypes.default.node,

  /**
   * This is a string key to identify the radio.  When using under the
   * RadioGroup context this must be unique.
   */
  value: _propTypes.default.string,

  /**
   * name passing to the radio input.  When using multiple Radios having the
   * same name on a page, the browser will treat them as a group.
   */
  name: _propTypes.default.string
};